import {Button, Modal} from 'react-bootstrap';
import { Subtract } from 'react-bootstrap-icons';
import './ForgotUsernameModal.css'

function ForgotUsernameModal({
    show,
    onClose,
    retrievedUsername
}) {
    const unsecuredCopyToClipboard = (text) => { const textArea = document.createElement("textarea"); textArea.value=text; document.body.appendChild(textArea); textArea.focus();textArea.select(); try{document.execCommand('copy')}catch(err){console.error('Unable to copy to clipboard',err)}document.body.removeChild(textArea)};
    console.log(retrievedUsername)
    return (
        <>
            <Modal show={show} onHide={onClose} animation={false}>
                <Modal.Header closeButton>
                    Your Username:
                </Modal.Header>
                <Modal.Body className='login-trouble-buttons'>
                    {retrievedUsername}
                    <Button variant="primary" onClick={()=> {
                        if (window.isSecureContext && navigator.clipboard) {
                            console.log('SECURE')
                            navigator.clipboard.writeText(retrievedUsername);
                          } else {
                            console.log('INSECURE')
                            unsecuredCopyToClipboard(retrievedUsername);
                          }
                    }}>
                        Copy
                        <Subtract className='copy-icon'/>
                    </Button>

                </Modal.Body>
            </Modal>
        </>       
    );

}

export default ForgotUsernameModal;